import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import {
  List
} from "@lockerpm/design";

import {
  DeleteOutlined,
  FacebookOutlined,
  GlobalOutlined,
  PhoneOutlined,
  ClockCircleOutlined,
  PlusOutlined
} from "@ant-design/icons";

import commonComponents from "../../../components/common";
import itemsComponents from "../../../components/items";
import checkScamComponents from "./components";

import scamReportServices from "../../../services/scam-report";

import global from "../../../config/global";
import common from "../../../utils/common";

const ReportCard = ({
  report,
  onRemove = () => {}
}) => {
  const { t } = useTranslation();
  return  <div className="flex flex-col gap-4 w-full">
    <div className="flex items-center justify-between w-full">
      <div className="flex gap-3 items-center">
        <div className="w-[40px] h-[40px] rounded-full border border-solid border-gray-200 bg-gray-100 flex items-center justify-center text-xl">
          {
            report.type === 'phone' ? <PhoneOutlined /> : (report.type === 'facebook' ? <FacebookOutlined /> : <GlobalOutlined />)
          }
        </div>
        <p className="font-semibold">
          {report.value}
        </p>
      </div>
      <DeleteOutlined
        className="text-xl cursor-pointer text-black-500"
        onClick={() => onRemove(report)}
      />
    </div>
    <div className="flex items-center gap-6">
      <div className="border border-solid border-warning-200 bg-warning-50 rounded-2xl">
        <p className="text-warning-700 font-semibold text-sm px-[10px] py-[2px]">
          {t(`scam_type.${report.phishing_type}`)}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <ClockCircleOutlined />
        <p>{common.timeFromNow(report.created_time)}</p>
        {
          report.is_anonymous && <>
            <p>-</p>
            <p>{t('scam_my_report.posted_anonymously')}</p>
          </>
        }
      </div>
    </div>
    {
      report.description && <div className="rounded-md p-4 bg-gray-100">
        <p className="text-md">{report.description}</p>
      </div>
    }
  </div>
}

const ScamMyReport = () => {
  const { t } = useTranslation();
  const { PageHeader } = commonComponents;
  const { NoData } = itemsComponents;
  const { ReportFormData, ReportFilter } = checkScamComponents;

  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({
    page: 1,
    size: 5,
    orderField: 'revisionDate',
    orderDirection: 'desc',
    searchText: '',
  })
  const [total, setTotal] = useState(0);
  const [reports, setReports] = useState([])
  const [formVisible, setFormVisible] = useState(false);

  useEffect(() => {
    fetchScamReports();
  }, [JSON.stringify(params)])

  const fetchScamReports = () => {
    const p = {
      page: params.page,
      size: params.size,
      q: params.searchText,
      sort: `created_time_${params.orderDirection}`
    }
    setLoading(p.size === 5);
    scamReportServices.get_scam_reports(p).then((res) => {
      setReports(res.results);
      setTotal(res.count);
    }).catch((error) => {
      global.pushError(error)
    }).finally(() => {
      setLoading(false);
    })
  }
  const removeReport = (report) => {
    global.confirm(() => {
      scamReportServices.delete_scam_report(report.id).then(() => {
        setReports(reports.filter((r) => r.value !== report.value))
      }).catch((error) => {
        global.pushError(error)
      })
    })
  }

  return (
    <div
      className="scam-my-report layout-content"
      onScroll={(e) => common.scrollEnd(e, params, total, setParams, true, 5)}
    >
      <PageHeader
        title={t('scam_my_report.title')}
        total={total}
        actions={[
          {
            key: 'add',
            label: t('button.new_report'),
            type: 'primary',
            icon: <PlusOutlined />,
            disabled: loading,
            click: () => setFormVisible(true)
          }
        ]}
      />
      <div className="mt-4 flex flex-col gap-2">
        {
          total > 0 && <ReportFilter
            className=""
            loading={loading}
            params={params}
            setParams={setParams}
          />
        }
        {
          total == 0 || loading ? <NoData loading={loading}/> : <List
            itemLayout="horizontal"
            dataSource={reports}
            renderItem={(item) => (
              <List.Item>
                <ReportCard
                  report={item}
                  onRemove={removeReport}
                />
              </List.Item>
            )}
          />
        }
      </div>
      <ReportFormData
        visible={formVisible}
        onClose={() => setFormVisible(false)}
        onReload={() => fetchScamReports()}
      />
    </div>
  );
}

export default ScamMyReport;